import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { CognitoService } from '@dash/randy/security/service/cognito.service';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[appAuthPermissionCheckInput]',
    standalone: false
})
export class AuthPermissionCheckInputDirective implements AfterViewInit, OnDestroy {
  private permissionString: string;
  private permissionsSubscription: Subscription;
  private viewInitialized = false;
  private readonly: boolean = false;

  @Input() set appAuthPermissionCheckInput(value: string) {
    this.permissionString = value;
    this.validatePermissions();
  }

  constructor(private elementRef: ElementRef, private cognitoService: CognitoService) {
    this.permissionsSubscription = this.cognitoService.permissions$.subscribe(() => {
      this.validatePermissions();
    });
  }

  ngOnDestroy(): void {
    this.permissionsSubscription.unsubscribe();
  }

  private validatePermissions(): void {
    if (!this.permissionString) {
      return;
    }

    let result = this.cognitoService.getPermissions(this.permissionString);
    this.readonly = !result;

    if (this.viewInitialized) {
      this.applyReadonly();
    }
  }

  ngAfterViewInit(): void {
    this.viewInitialized = true;
    this.applyReadonly();
  }

  private applyReadonly(): void {
    if (this.readonly) {
      this.elementRef.nativeElement.setAttribute('readonly', this.readonly);
    } else {
      this.elementRef.nativeElement.removeAttribute('readonly');
    }
  }
}
